import { z } from "zod";

import { ACH_ACCOUNT_TYPES } from "../types";

export const zipCodeSchema = z
  .string()
  .regex(/^\d{5}$/, "Enter a valid ZIP code");

const achFormBaseSchema = z.object({
  accountHolderName: z.string().trim().min(1, "Enter the account holder name"),
  accountNumber: z.string(),
  accountType: z.enum(ACH_ACCOUNT_TYPES, {
    errorMap: () => ({ message: "Select an account type" }),
  }),
  confirmAccountNumber: z.string(),
  routingNumber: z.string().regex(/^\d{9}$/, "Routing number must be 9 digits"),
});

export function createAchFormSchema({
  currentRoutingNumber,
}: {
  currentRoutingNumber?: string;
}): z.ZodEffects<typeof achFormBaseSchema> {
  return achFormBaseSchema.superRefine((values, context) => {
    const isAccountNumberRequired =
      values.routingNumber !== currentRoutingNumber;

    if (!values.accountNumber && !isAccountNumberRequired) return;

    if (!/^\d{4,17}$/.test(values.accountNumber)) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Enter a valid account number",
        path: ["accountNumber"],
      });
    }

    if (values.accountNumber !== values.confirmAccountNumber) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Account numbers don't match",
        path: ["confirmAccountNumber"],
      });
    }
  });
}

export type AchFormValues = z.infer<typeof achFormBaseSchema>;

export function digitsOnly(value: string, maxLength: number): string {
  return value.replaceAll(/\D/g, "").slice(0, maxLength);
}
